export default "__VITE_ASSET__vkT2HIb4__"